(() => {
  if (window.RoadRexMarketingConsent) return;
  window.RoadRexMarketingConsent = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const consent = form.querySelector('[data-rr-marketing-consent]');
    const email = form.querySelector('input[name="contact[email]"]');
    if (!consent?.checked || !email?.value) return;

    const payload = new URLSearchParams();
    payload.set('form_type', 'customer');
    payload.set('utf8', '✓');
    payload.set('contact[email]', email.value.trim());
    payload.set('contact[tags]', 'newsletter, enquiry lead, Road Rex 4x4');

    fetch(`${window.Shopify?.routes?.root || '/'}contact#contact_form`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: payload.toString(),
      credentials: 'same-origin',
      keepalive: true,
    }).catch(() => {});
  }, true);
})();
